<style lang="scss" scoped></style>

<template>
    <div>
        <el-form :loading="loading" :success="success" @submit="handleFormSubmit" ref="jobForm" disclaimer="velden met een * zijn verplicht">
            <div class="grid grid-cols-3 gap-24">
                <div class="col-span-3 lg:col-span-2">
                    <div class="grid gap-24 grid-cols-2">
                        <div class="col-span-2 lg:col-span-1">
                            <el-input v-model="formData.firstname" name="first_name" label="Voornaam" rules="required" class="mb-24" />
                            <el-input v-model="formData.lastname" name="last_name" label="Naam" rules="required" class="" />
                        </div>
                        <div class="col-span-2 lg:col-span-1">
                            <el-input v-model="formData.email" type="email" name="email" label="E-mail" rules="required|email" class="mb-24" />
                            <el-input v-model="formData.phone" name="phone" label="Telefoon" rules="required" class="" />
                        </div>
                        <div class="col-span-2 grid grid-cols-4 gap-24">
                            <el-input class="col-span-3" v-model="formData.street" name="street" label="Straat" rules="required" />
                            <el-input class="col-span-1" v-model="formData.street_nr" name="street_nr" label="Nr" rules="required" />
                            <el-input class="col-span-2" v-model="formData.postal_code" name="postal_code" label="Postcode" rules="required" />
                            <el-input class="col-span-2" v-model="formData.city" name="city" label="Stad" rules="required" />
                        </div>
                    </div>
                </div>
                <div class="col-span-3 lg:col-span-1">
                    <el-input v-model="formData.birthdate" type="date" name="day_of_birth" label="Geboortedatum" rules="required" class="mb-24" />
                    <el-input v-model="formData.motivation" type="textarea" name="motivation" label="Motivatie" class="mb-24" />
                    <el-input v-model="formData.link_cv" :multiple="false" type="fileupload" name="cv" label="Upload je CV" placeholder="Upload je CV (.pdf, .docx)" />
                </div>
                <div class="col-span-3 mb-24 mt-16">
                    <el-input type="checkbox" name="terms" rules="required" label="Ik ga akkoord met de <a  class='text-green' href='/algemene-voorwaarden' target='_blank'>algemene voorwaarden</a>." />
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import hasForm from "../../mixins/components/has-form";

export default {
    name: "Forms.JobForm",

    mixins: [hasForm],

    props: {
        jobId: {
            type: [String, Number],
            required: true
        },
        assignedUserEmail: {
            type: String,
            required: false
        }
    },

    data: () => ({
        formData: {
            firstname: "",
            lastname: "",
            email: "",
            phone: "",
            birthdate: "",
            street: "",
            street_nr: "",
            postal_code: "",
            city: "",
            motivation: "",
            link_cv: [],
            job_id: null
        }
    }),

    methods: {
        handleFormSubmit() {
            this.beforeSubmit();
            const fd = new FormData();
            fd.append("firstname", this.formData.firstname);
            fd.append("lastname", this.formData.lastname);
            fd.append("email", this.formData.email);
            fd.append("phone", this.formData.phone);
            fd.append("birthdate", this.formData.birthdate);
            fd.append("street", this.formData.street);
            fd.append("street_nr", this.formData.street_nr);
            fd.append("postal_code", this.formData.postal_code);
            fd.append("city", this.formData.city);
            fd.append("motivation", this.formData.motivation);
            if (this.formData.link_cv.length > 0) {
                fd.append("link_cv", this.formData.link_cv[0]);
            }
            fd.append("job_id", this.jobId);

            //files
            axios
                .post("/api/job-application", fd, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(response => this.handleSuccess())
                .catch(e => this.handleError(e))
                .finally(() => (this.loading = false));
        }
    }
};
</script>
